'use strict';

var helper = require('../helper');

function formatPromotionForAnalytics (promotions) {
    if (!promotions) {
        return;
    }

    var promotionsToSend = [];

    if (promotions.length !== undefined) {
        for (let i = 0; i < promotions.length; i++) {
            let obj = promotions[i];
            let objToPush = {
                id: obj.id,
                position: obj.position,
                creative: obj.creative,
                name: obj.name
            };
            promotionsToSend.push(objToPush);
        }

        return promotionsToSend;
    } else {
        let objToPush = {
            id: promotions.id,
            position: promotions.position,
            creative: promotions.creative,
            name: promotions.name
        };
        promotionsToSend.push(objToPush);
        return promotionsToSend;
    }
}

module.exports = {

    pushPromotionListImpression (promotions) {
        var promotionsToSend = formatPromotionForAnalytics(promotions);
        if (!promotions || promotions.length === 0 || !promotionsToSend || promotionsToSend.length < 1) {
            return;
        }

        let pushObject = {
            'event': 'view_promotion',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'ecommerce': {
                'promoView': {
                    'promotions': promotionsToSend
                }
            }
        };

        helper.log('Pushing promotions list impression!', true);
        helper.push({ecommerce: null});
        helper.push(pushObject);
    },

    pushPromotionClickImpression (promotion) {
        var promotionToSend = formatPromotionForAnalytics(promotion);
        if (!promotion || !promotionToSend || promotionToSend.length < 1) {
            return;
        }

        let pushObject = {
            'event': 'select_promotion',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'ecommerce': {
                'promoClick': {
                    'promotions': promotionToSend
                }
            }
        };

        helper.log('Pushing promotion click impression!', true);
        helper.push({ecommerce: null});
        helper.push(pushObject);
    },

    pushInfoBannerClickImpression (action, name) {
        if (!name || !action) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '3',
            'eventname': 'banner_info',
            'label': name,
            'text': action
        };

        helper.log('Pushing info banner click impression!', true);
        helper.push(pushObject);
    },

    // Customer Service - Link
    pushCustomerServiceItemClick (topic) {
        if (!topic) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '20',
            'eventname': 'faq',
            'action': 'clic_on_topic',
            'text': topic
        };

        helper.log('Pushing customer service topic click for ' + topic + '!', true);
        helper.push(pushObject);
    },

    // Customer Service - Popular questions
    pushCustomerServicePopularQuestionItemClick (topic) {
        if (!topic) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '21',
            'eventname': 'faq',
            'action': 'general',
            'text': topic
        };

        helper.log('Pushing customer service popular question item click for ' + topic + '!', true);
        helper.push(pushObject);
    },

    // Customer Service - Questions in single page
    pushCustomerServiceItemExpand (topic, name) {
        if (!topic || !name) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '22',
            'eventname': 'faq',
            'action': topic,
            'text': name
        };

        helper.log('Pushing customer service topic expand for ' + topic + ', ' + name + '!', true);
        helper.push(pushObject);
    }

};
